import { memo } from "react";
import { useDrop } from "react-dnd";
import { Typography } from "@material-ui/core";
import { GetTermEvents } from "./TermComponents.js";
import AddEventToTermDialog from "./AddEventToTermDialog.js";

export const EventDropBox = memo(function EventDropBox({
  lastDroppedComponent,
  closeAddDialog,
  onDrop,
  passObjOptions,
  periodStartDate,
  periodEndDate,
  periodName
}) {
  const termEvents = GetTermEvents();
  const acceptList = [];
  termEvents.map((event) => {
    acceptList.push(event.name);
  });

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: acceptList,
    drop(_item, monitor) {
      onDrop(monitor.getItemType());
      return undefined;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      draggingColor: monitor.getItemType(),
    }),
  });
  return (
    <div
      ref={drop}
      role="EventDropBox"
      style={{
        border: "1px dashed grey",
        borderRadius: "8px",
        height: "70px",
        textAlign: "center",
        display: "flex",
      }}
    >
      <Typography
        variant="h6"
        style={{
          display: "flex",
          alignItems: "center",
          padding: 5,
        }}
      >
        Drag and drop Event object into this box.
      </Typography>
      {!canDrop && acceptList.includes(lastDroppedComponent) && (
        <AddEventToTermDialog
          closeDialog={closeAddDialog}
          handleAddTerm={passObjOptions}
          eventType={lastDroppedComponent}
          startDate={periodStartDate}
          endDate={periodEndDate}
          periodName={periodName}
        />
      )}
    </div>
  );
});
